/**
 * Field name for the company name column in the data table
 * Used to identify which cell should show tooltip and reduced opacity when row is disabled
 */
export const COMPANY_NAME_FIELD = 'borrowerName';

/**
 * Field name for the deal status column in the data table
 * Used to scope next-status filtering and last-stage logic to the Status column only
 */
export const DEAL_STATUS_FIELD = 'dealStatus';

/**
 * Tooltip message shown when hovering over a disabled company name cell
 * Displayed when row is disabled based on deal status configuration
 */
export const DISABLED_ROW_TOOLTIP_MESSAGE = 'You are not eligible to open this company';

export const STYLE_CONSTANTS = {
    COLORS: {
        DEFAULT: {
            TEXT: '#9D9D9D',
            ICON_FILL: '#9D9D9D',
            HOVER_BG: '#F2E8FF',
            HOVER_FILL: '#6021B3',
            HOVER_TEXT: '#6021B3',
            BG: 'transparent',
        },
        PENDING: {
            TEXT: '#DF666A',
            ICON_FILL: '#DF666A',
            HOVER_BG: '#ffeeee',
            HOVER_FILL: '#DF666A',
            HOVER_TEXT: '#DF666A',
            BG: 'transparent',
        },
        RESOLVED: {
            TEXT: '#9d9d9d',
            ICON_FILL: '#CBCBCB',
            HOVER_BG: '#F2E8FF',
            HOVER_FILL: '#6021B3',
            HOVER_TEXT: '#6021B3',
            BG: 'transparent',
        },
        UPLOAD_DATA: {
            TEXT: '#6021B3',
            ICON_FILL: '#6021B3',
            HOVER_BG: '#F2E8FF',
            HOVER_FILL: '#6021B3',
            HOVER_TEXT: '#6021B3',
            BG: '#F2E8FF',
        },
    },
    LABELS: {
        NONE: 'None',
        COMPLETED: 'Completed',
    },
} as const;
